export default {
  home: 'Accueil',
  menu: 'Menu',
  orders: 'Commandes',
};
